import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef, useState } from 'react';
import { Button, Combobox, Divider, Flex, Heading, Link, MultiCombobox, Notice, RadioGroup, Spinner, SrOnly, Text } from '@applyboard/crystal-ui';
import { useEventTracker, useSetPageMeta } from '@applyboard/ui-utils';
import { PeopleImmigration } from "./components/PeopleImmigration";
import { SuggestionItem } from "./components/SuggestionItem";
import { AGE_OPTIONS, COUNTRY_OF_CITIZENSHIP_OPTIONS, GENDER_OPTIONS, IRCC_LINK, PROGRAM_LEVEL_OPTIONS, PROVINCE_OPTIONS, SUGGEST_PAGE_SIZE, VISA_VS_STUDY_PERMIT_LINK } from "./consts";
import { useVisaProbabilitySuggestionsV2 } from "./data/visaProbability";
import { useFormValidation } from "./hooks/useFormValidation";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var VisaProbability = function VisaProbability() {
  useSetPageMeta({
    title: 'Visa Calculator'
  });
  var formTopRef = useRef(null);
  var formResultsRef = useRef(null);
  var scrollToErrors = function scrollToErrors() {
    var _formTopRef$current;
    (_formTopRef$current = formTopRef.current) === null || _formTopRef$current === void 0 ? void 0 : _formTopRef$current.scrollIntoView({
      behavior: 'smooth'
    });
  };
  var scrollToResults = function scrollToResults() {
    var _formResultsRef$curre;
    (_formResultsRef$curre = formResultsRef.current) === null || _formResultsRef$curre === void 0 ? void 0 : _formResultsRef$curre.scrollIntoView({
      behavior: 'smooth'
    });
  };
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    countryOfCitizenship = _useState2[0],
    setCountryOfCitizenship = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    provinces = _useState4[0],
    setProvinces = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    levelsOfStudy = _useState6[0],
    setLevelsOfStudy = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    age = _useState8[0],
    setAge = _useState8[1];
  var _useState9 = useState('Male'),
    _useState10 = _slicedToArray(_useState9, 2),
    gender = _useState10[0],
    setGender = _useState10[1];
  var _useFormValidation = useFormValidation({
      countryOfCitizenship: countryOfCitizenship,
      age: age,
      gender: gender
    }),
    formErrors = _useFormValidation.formErrors,
    showErrorDisclaimer = _useFormValidation.showErrorDisclaimer,
    setShowErrorDisclaimer = _useFormValidation.setShowErrorDisclaimer,
    createFormErrors = _useFormValidation.createFormErrors;
  var _useVisaProbabilitySu = useVisaProbabilitySuggestionsV2(),
    visaProbabilitySuggestions = _useVisaProbabilitySu.visaProbabilitySuggestions,
    isLoadingVisaProbabilitySuggestions = _useVisaProbabilitySu.isLoadingVisaProbabilitySuggestions;
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    suggestResult = _useState12[0],
    setSuggestResult = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    paginatedSuggestions = _useState14[0],
    setPaginatedSuggestions = _useState14[1];
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    topScore = _useState16[0],
    setTopScore = _useState16[1];
  var _useState17 = useState(1),
    _useState18 = _slicedToArray(_useState17, 2),
    page = _useState18[0],
    setPage = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showLoadMore = _useState20[0],
    setShowLoadMore = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showFinalResult = _useState22[0],
    setShowFinalResult = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isRequestError = _useState24[0],
    setIsRequestError = _useState24[1];
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var onLoadMore = function onLoadMore() {
    if (suggestResult) {
      var isLastPage = page * 3 >= suggestResult.length;
      setPaginatedSuggestions(isLastPage ? suggestResult : suggestResult.slice(0, page * SUGGEST_PAGE_SIZE));
      setShowLoadMore(!isLastPage);
      setPage(page + 1);
      trackEvent({
        event: 'Visa Calculator - Clicked Load More Results',
        group: 'Returned Results'
      });
    }
  };
  var trackEventsOnSubmit = function trackEventsOnSubmit() {
    trackEvent({
      data: {
        'Country of citizenship': countryOfCitizenship,
        Age: age,
        Gender: gender,
        'Level of study': levelsOfStudy,
        'Destination province': provinces
      },
      event: 'Visa Calculator - Clicked Calculate Visa Score',
      group: 'Returned Results'
    });
  };
  var onCalculateVisaScore = function onCalculateVisaScore() {
    setIsRequestError(false);
    trackEventsOnSubmit();
    var _createFormErrors = createFormErrors(),
      isValid = _createFormErrors.isValid;
    if (isValid) {
      visaProbabilitySuggestions({
        countryOfCitizenship: countryOfCitizenship,
        age: age,
        gender: gender,
        province: provinces,
        levelOfStudy: levelsOfStudy
      }, {
        onSuccess: function onSuccess(resp) {
          trackEvent({
            event: 'Visa Calculator - Successfully Received Visa Probability Score',
            group: 'RPJ Adoption Metrics'
          });
          var sortedResp = resp.sort(function (a, b) {
            var _PROGRAM_LEVEL_OPTION, _PROGRAM_LEVEL_OPTION2;
            var aQuickSearchMapping = (_PROGRAM_LEVEL_OPTION = PROGRAM_LEVEL_OPTIONS.find(function (_ref) {
              var value = _ref.value;
              return value === a.levelOfStudy;
            })) === null || _PROGRAM_LEVEL_OPTION === void 0 ? void 0 : _PROGRAM_LEVEL_OPTION.quickSearchProgramLevelMapping;
            var isASupportedLevel = !!aQuickSearchMapping && aQuickSearchMapping.length > 0;
            var bQuickSearchMapping = (_PROGRAM_LEVEL_OPTION2 = PROGRAM_LEVEL_OPTIONS.find(function (_ref2) {
              var value = _ref2.value;
              return value === b.levelOfStudy;
            })) === null || _PROGRAM_LEVEL_OPTION2 === void 0 ? void 0 : _PROGRAM_LEVEL_OPTION2.quickSearchProgramLevelMapping;
            var isBSupportedLevel = !!bQuickSearchMapping && bQuickSearchMapping.length > 0;
            if (isASupportedLevel && isBSupportedLevel) {
              return b.approvalProbability - a.approvalProbability;
            } else if (isASupportedLevel) {
              return -1;
            } else if (isBSupportedLevel) {
              return 1;
            } else {
              return b.approvalProbability - a.approvalProbability;
            }
          });
          setShowErrorDisclaimer(false);
          setShowFinalResult(true);
          setSuggestResult(sortedResp);
          setTopScore(sortedResp[0].approvalProbability);
          if (SUGGEST_PAGE_SIZE < sortedResp.length) {
            setPaginatedSuggestions(sortedResp.slice(0, SUGGEST_PAGE_SIZE));
            setPage(2);
            setShowLoadMore(true);
          } else {
            setPaginatedSuggestions(sortedResp);
            setShowLoadMore(false);
          }
          scrollToResults();
        },
        onError: function onError() {
          setIsRequestError(true);
          setShowErrorDisclaimer(true);
          scrollToErrors();
        }
      });
    } else {
      scrollToErrors();
    }
  };
  return _jsx("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      maxWidth: '1200px',
      margin: 'auto',
      padding: '24px',
      backgroundColor: 'white'
    },
    children: _jsxs("div", {
      ref: formTopRef,
      children: [_jsxs(Flex, {
        align: "center",
        gap: 4,
        pb: 4,
        pl: 2,
        children: [_jsx(Flex.Item, {
          as: "aside",
          grow: 0,
          shrink: 0,
          basis: 75,
          children: _jsx(PeopleImmigration, {})
        }), _jsx(Flex.Item, {
          as: "main",
          grow: 1,
          children: _jsx(Heading, {
            level: 1,
            variant: "headlineL",
            children: "Check Your Visa Score"
          })
        })]
      }), _jsxs(Flex, {
        direction: "column",
        align: "stretch",
        gap: 4,
        pb: 4,
        children: [_jsx(Text, {
          intent: "secondary",
          variant: "bodyM",
          children: "Enter your details to check the likelihood you could get a visa based on historical trends."
        }), _jsxs(Text, {
          intent: "secondary",
          variant: "labelS",
          children: ["Score is out of 100 and represents how many students with similar characteristics may receive a", ' ', _jsxs("a", {
            href: VISA_VS_STUDY_PERMIT_LINK,
            target: "_blank",
            rel: "noreferrer",
            children: ["Canadian visa/study permit. ", _jsx(SrOnly, {
              children: "(Opens in new tab)"
            })]
          })]
        }), showErrorDisclaimer ? _jsx(Flex.Item, {
          children: _jsx(Notice, {
            intent: "negative",
            children: isRequestError ? 'Offline. Failure to load page, please check your connection or try again later.' : 'Please fill out all of the missing requirements.'
          })
        }) : null]
      }), _jsxs(Flex, {
        direction: "column",
        gap: 4,
        pt: 2,
        children: [_jsx(Flex.Item, {
          children: _jsx(Combobox, {
            required: true,
            placeholder: "Country of Citizenship",
            label: "Country of Citizenship",
            value: countryOfCitizenship,
            onChange: function onChange(value) {
              return setCountryOfCitizenship(value);
            },
            invalid: !!formErrors.countryOfCitizenship,
            helpText: formErrors.countryOfCitizenship,
            type: "text",
            children: COUNTRY_OF_CITIZENSHIP_OPTIONS.map(function (_ref3) {
              var label = _ref3.label,
                value = _ref3.value;
              return _jsx(Combobox.Option, {
                value: value,
                label: label
              }, value);
            })
          })
        }), _jsx(Flex.Item, {
          children: _jsx(Combobox, {
            required: true,
            placeholder: "Age",
            label: "Age",
            value: age,
            onChange: function onChange(value) {
              return setAge(value);
            },
            invalid: !!formErrors.age,
            helpText: formErrors.age,
            children: AGE_OPTIONS.map(function (_ref4) {
              var label = _ref4.label,
                value = _ref4.value;
              return _jsx(Combobox.Option, {
                value: value,
                label: label
              }, value);
            })
          })
        }), _jsx(Flex.Item, {
          children: _jsx(RadioGroup, {
            required: true,
            label: "Gender",
            "aria-label": "gender",
            value: gender,
            onChange: function onChange(value) {
              setGender(value);
            },
            children: _jsx(Flex, {
              direction: "row",
              gap: 4,
              children: GENDER_OPTIONS.map(function (_ref5) {
                var value = _ref5.value,
                  label = _ref5.label;
                return _jsx(Flex.Item, {
                  children: _jsx(RadioGroup.Option, {
                    label: label,
                    value: value
                  }, value)
                }, value);
              })
            })
          })
        }), _jsx(Flex.Item, {
          children: _jsx(MultiCombobox, {
            helpText: "Leave blank for best results",
            label: "Desired level(s) of study",
            placeholder: "Desired level(s) of study",
            value: levelsOfStudy,
            onChange: function onChange(value) {
              return setLevelsOfStudy(value);
            },
            children: PROGRAM_LEVEL_OPTIONS.map(function (_ref6) {
              var label = _ref6.label,
                value = _ref6.value;
              return _jsx(MultiCombobox.Option, {
                label: label,
                value: value
              }, value);
            })
          })
        }), _jsx(Flex.Item, {
          children: _jsx(MultiCombobox, {
            helpText: "Leave blank for best results",
            label: "Desired destination province(s)",
            placeholder: "Desired destination province(s)",
            value: provinces,
            onChange: function onChange(value) {
              return setProvinces(value);
            },
            children: PROVINCE_OPTIONS.map(function (_ref7) {
              var label = _ref7.label,
                value = _ref7.value;
              return _jsx(MultiCombobox.Option, {
                label: label,
                value: value
              }, value);
            })
          })
        }), _jsx(Flex.Item, {
          children: _jsx(Button, {
            intent: "primary",
            onClick: onCalculateVisaScore,
            children: "Calculate Visa Score"
          })
        })]
      }), isLoadingVisaProbabilitySuggestions && _jsxs(Flex, {
        align: "center",
        direction: "column",
        gap: 4,
        pt: 4,
        pb: 4,
        pl: 2,
        children: [_jsx(Flex.Item, {
          children: _jsx(Text, {
            children: "Calculating your visa probability scores..."
          })
        }), _jsx(Flex.Item, {
          children: _jsx(Spinner, {
            size: "lg"
          })
        })]
      }), !isLoadingVisaProbabilitySuggestions && showFinalResult && _jsx("div", {
        ref: formResultsRef,
        children: _jsxs(Flex, {
          align: "center",
          direction: "column",
          gap: 4,
          p: 8,
          children: [_jsx(Flex.Item, {
            children: _jsx(Heading, {
              level: 3,
              variant: "headlineM",
              children: "Your Visa Scores"
            })
          }), _jsx(Flex.Item, {
            children: _jsxs(Text, {
              variant: "labelS",
              as: "p",
              children: ["Based on historical trends, we estimate that as many as ", topScore, " out of 100 students with similar characteristics would receive a", ' ', _jsx(Link, {
                href: VISA_VS_STUDY_PERMIT_LINK,
                mode: "override_user_choice_and_open_in_new_tab",
                children: "Canadian visa/study permit."
              })]
            })
          })]
        })
      }), !isLoadingVisaProbabilitySuggestions && showFinalResult && paginatedSuggestions && paginatedSuggestions.length > 0 && _jsx(Flex, {
        direction: "column",
        align: "start",
        gap: 4,
        children: paginatedSuggestions.map(function (suggestion, index) {
          var programLevelInfoForSuggestion = PROGRAM_LEVEL_OPTIONS.find(function (_ref8) {
            var value = _ref8.value;
            return value === suggestion.levelOfStudy;
          });
          var quickSearchMapping = programLevelInfoForSuggestion === null || programLevelInfoForSuggestion === void 0 ? void 0 : programLevelInfoForSuggestion.quickSearchProgramLevelMapping;
          return _jsxs(Flex.Item, {
            children: [_jsx(SuggestionItem, {
              province: suggestion.province,
              levelOfStudy: suggestion.levelOfStudy,
              score: suggestion.approvalProbability,
              isTopScore: index === 0,
              quickSearchProgramLevels: programLevelInfoForSuggestion === null || programLevelInfoForSuggestion === void 0 ? void 0 : programLevelInfoForSuggestion.quickSearchProgramLevelMapping,
              isSupportedLevel: !!quickSearchMapping && quickSearchMapping.length > 0,
              index: index
            }), index < paginatedSuggestions.length - 1 ? _jsx(Divider, {}) : null]
          }, JSON.stringify(suggestion));
        })
      }), !isLoadingVisaProbabilitySuggestions && showLoadMore && _jsx(Flex, {
        p: 4,
        align: "center",
        justify: "center",
        children: _jsx(Flex.Item, {
          children: _jsx(Button, {
            emphasis: "outlined",
            intent: "secondary",
            onClick: onLoadMore,
            children: "Load More"
          })
        })
      }), _jsxs(Flex, {
        direction: "column",
        gap: 6,
        children: [_jsx(Flex.Item, {
          children: _jsx(Divider, {})
        }), _jsx(Flex.Item, {
          children: _jsxs(Text, {
            variant: "labelS",
            as: "p",
            children: ["Results may vary. This module uses historical data courtesy of", ' ', _jsxs("a", {
              href: IRCC_LINK,
              target: "_blank",
              rel: "noopener noreferrer",
              children: ["Immigration, Refugees and Citizenship Canada (IRCC)", ' ', _jsx(SrOnly, {
                children: "(Opens in new tab)"
              })]
            }), ' ', "and machine learning to predict the percentage of applicants with similar characteristics that would likely qualify for a Canadian study permit. The model combines the approval rates of groups of applicants who share the same subsets of features, to infer the approval chance of people with the whole set of features, using machine learning. Please note the actual approval chances depend on multiple other factors that are not collected nor considered here. These predictions also assume the candidate is eligible for the level of study and able to receive a letter of acceptance from a designated learning institution. The information on the website is not intended to be immigration advice and third-party professional advice should be obtained with respect to any visa application you may pursue."]
          })
        })]
      })]
    })
  });
};